import { Content } from '@CS/components/Form';
import { useTranslation } from '@CS/hooks';
import CSS from './Description.module.css';

export const Description = () => {
  const { title, description } = useTranslation(Content);

  return (
    <div className={CSS.description}>
      <h3>{title}</h3>
      <p>{description}</p>
    </div>
  );
};
